import styled from '@emotion/styled';

const StyledList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export default StyledList;
